(() => {
  angular
    .module('gm.common.filters')
    .filter('gmAbsValue', gmAbsValueFilter);

  function gmAbsValueFilter() {
    'ngInject';

    return (input) => {
      if (isNaN(input)) {
        return '';
      }
      return Math.abs(parseFloat(input));
    };
  }
})();
